const time = [
  { label: "Morning <br>(6am - 12pm)", value: "1" },
  { label: "Afternoon <br>(12pm - 6pm)", value: "2" },
  { label: "Evening <br>(6pm - 12am)", value: "3" },
];

export default time;